import { backendGet } from "@accredo/fe-shared/services/dataService.js";

/**
 * Fetches a document's file authenticated (the access token lives in
 * sessionStorage, so a plain `<a href>` to download_url can't reach it) and
 * saves it under the document's own filename. Shared by the row's download
 * button and the preview's, so both go through the same request.
 */
export async function downloadDocument(document, { enqueueSnackbar } = {}) {
  const blob = await backendGet(document.download_url, {
    label: document.filename,
    enqueueSnackbar,
    options: { responseType: "blob" },
  });

  if (!blob) {
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = window.document.createElement("a");
  link.href = url;
  link.download = document.filename;
  link.click();
  URL.revokeObjectURL(url);
}

/**
 * Fetches the selected documents as a single zip via
 * GET /data/documents/bulk-download?filter[id]=… and saves it, the same way
 * downloadDocument() does for one document.
 */
export async function downloadSelectedDocuments(ids, { enqueueSnackbar } = {}) {
  const blob = await backendGet("/data/documents/bulk-download", {
    label: "Dokumente.zip",
    enqueueSnackbar,
    options: {
      responseType: "blob",
      params: { filter: { id: ids.join(",") } },
    },
  });

  if (!blob) {
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = window.document.createElement("a");
  link.href = url;
  link.download = "Dokumente.zip";
  link.click();
  URL.revokeObjectURL(url);
}
